import React from 'react';
import cn from 'classnames';

import UserDevice from 'services/user-device';
import Icon from '../Icon';

import live from 'assets/svg/mob-live.svg';
import './LiveIcon.scss';

const LiveIcon: React.FC = () => (
    <Icon
        glyph={live}
        styleName={cn('container', {
            'is-mob': UserDevice.getInstance()?.isDeviceMobile(),
        })}
        className="__app-LiveIcon-container"
    />
);

export default LiveIcon;
